import React from 'react';
import classNames from 'classnames';

import {Dropdown} from '@homeaway/react-dropdown';

import './Flags.less';

export class Flags extends React.Component {
    get className() {
        return classNames(
            'site-header-flags',
            {'site-header-flags--columns': this.props.showColumns}
        );
    }

    onClickFlag = /* istanbul ignore next */ (event) => {
        const countryCode = event.currentTarget.dataset.countryCode;

        // @ts-ignore
        if (countryCode && window.edap) {
            // @ts-ignore
            window.edap.push((edap) => {
                const payload = {
                    eventaction: 'header-countryflag',
                    eventcategory: 'react-site-header',
                    eventlabel: 'countryCode',
                    eventvalue: countryCode,
                };
                edap.trigger('generic.event', payload);
            });
        }
    };

    renderItem = (flag) => (
        <a
            className={`site-header__link site-header-flags__flag ${flag.countryCode}`}
            data-bypass="true"
            data-country-code={flag.countryCode}
            href={flag.link}
            key={`${flag.countryCode}-${flag.link}`}
            onClick={this.onClickFlag}
            role={'menuitem'}
        >
            <i aria-hidden="true" className={`site-header-flags__flag-icon flag-${flag.countryCode}`} />
            <span className="site-header-flags__flag-text">{flag.text}</span>
        </a>
    );

    render() {
        if (!this.props.items) {
            return null;
        }

        let currentFlag = this.props.items[0];

        const toggle = (
            <button
                aria-haspopup="true"
                className="site-header-flags__toggle"
            >
                <span className="sr-only">{currentFlag.text}</span>
                <i aria-hidden="true" className={`flag-${currentFlag.countryCode}`} />
            </button>
        );

        return (
            <Dropdown
                className={this.className}
                customToggle={toggle}
                dropdownRight
                id="site-header-flags"
                label={currentFlag.text}
                tabIndex={-1}
            >
                <div aria-labelledby="site-header-flags" className="site-header-flags__dropdown-menu" role="menu">
                    {this.props.items.map(this.renderItem)}
                </div>
            </Dropdown>
        );
    }
}
